// import React, { useCallback, useEffect, useState } from 'react';
// import api from '../common/apiClient'; 
// import SummaryApi from '../common/SummaryApi';
// import { toast } from 'react-hot-toast';
// import { CheckCircle, XCircle, X, Image as ImageIcon, ExternalLink, ChevronDown, ChevronUp } from 'lucide-react';
// import moment from 'moment';

// // --- SUB COMPONENT: Handles the Expand/Collapse logic for items ---
// const ReturnItemsList = ({ items }) => {
//     const [expanded, setExpanded] = useState(false);

//     // Safety check
//     if (!items || items.length === 0) return null;

//     // Decide which items to render
//     // If expanded is true, show ALL. If false, show only the FIRST one.
//     const visibleItems = expanded ? items : [items[0]];
//     const remainingCount = items.length - 1;

//     return (
//         <div className="space-y-3">
//             {visibleItems.map((item, idx) => {
//                 // Image Logic
//                 const imgUrl = item.variantId?.images?.[0] || item.productId?.images?.[0] || "";
                
//                 return (
//                     <div key={idx} className="flex gap-2 items-start animate-in fade-in duration-300">
//                         <img 
//                             src={imgUrl} 
//                             alt="" 
//                             className="w-10 h-10 object-cover rounded border bg-gray-100 flex-shrink-0"
//                         />
//                         <div>
//                             <div className="text-xs font-semibold text-gray-700 line-clamp-1 w-32" title={item.productId?.productName}>
//                                 {item.productId?.productName}
//                             </div>
//                             <div className="text-[10px] text-gray-500 flex flex-col">
//                                 {item.variantId?.colorName && <span>Color: {item.variantId.colorName}</span>}
//                                 {item.sizeId?.size && <span>Size: {item.sizeId.size}</span>}
//                                 <span className='font-medium text-gray-700'>Qty: {item.quantity}</span>
//                             </div>
//                         </div>
//                     </div>
//                 );
//             })}

//             {/* Show More / Show Less Button */}
//             {items.length > 1 && (
//                 <button 
//                     onClick={() => setExpanded(!expanded)} 
//                     className="text-[10px] font-bold text-blue-600 hover:text-blue-800 hover:underline flex items-center gap-1 mt-1 transition-colors"
//                 >
//                     {expanded ? (
//                         <>Show Less <ChevronUp size={12} /></>
//                     ) : (
//                         <>+{remainingCount} more items <ChevronDown size={12} /></>
//                     )}
//                 </button>
//             )}
//         </div>
//     );
// };

// // --- MAIN COMPONENT ---
// const AllReturnOrders = () => {
//     const [orders, setOrders] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [selectedTab, setSelectedTab] = useState("");
//     const [actionLoading, setActionLoading] = useState(null);

//     // --- Reject Modal State ---
//     const [showRejectModal, setShowRejectModal] = useState(false);
//     const [rejectOrderId, setRejectOrderId] = useState(null);
//     const [rejectNote, setRejectNote] = useState("");

//     // --- Image Preview Modal State ---
//     const [showImageModal, setShowImageModal] = useState(false);
//     const [previewImages, setPreviewImages] = useState([]);

//     // --- 1. Fetch Orders ---
//     const fetchOrders = useCallback(async () => {
//         setLoading(true);
//         try {
//             let url = SummaryApi.getReturnedOrders.url;
//             if (selectedTab) {
//                 url += `?status=${selectedTab}`;
//             }

//             const response = await api({
//                 url: url,
//                 method: SummaryApi.getReturnedOrders.method,
//                 withCredentials: true
//             });

//             const responseData = response.data;

//             if (responseData.success) {
//                 setOrders(responseData.data || []); 
//             } else {
//                 toast.error(responseData.message || "Failed to fetch orders");
//             }
//         } catch (error) {
//             console.error(error);
//             const msg = error.response?.data?.message || "Something went wrong";
//             toast.error(msg);
//         } finally {
//             setLoading(false);
//         }
//     }, [selectedTab]);

//     useEffect(() => {
//         fetchOrders();
//     }, [fetchOrders]);

//     // --- 2. Handle Action ---
//     const handleAction = async (orderId, status, note = "") => {
//         setActionLoading(orderId);
//         try {
//             const response = await api({
//                 url: SummaryApi.adminReturnAction.url(orderId),
//                 method: SummaryApi.adminReturnAction.method,
//                 withCredentials: true,
//                 headers: { "Content-Type": "application/json" },
//                 data: { status, note }
//             });

//             if (response.data.success) {
//                 toast.success(response.data.message);
//                 fetchOrders();
//                 setShowRejectModal(false);
//                 setRejectNote("");
//             } else {
//                 toast.error(response.data.message);
//             }
//         } catch (error) {
//             const msg = error.response?.data?.message || "Error updating status";
//             toast.error(msg);
//         } finally {
//             setActionLoading(null);
//         }
//     };

//     const openRejectModal = (orderId) => {
//         setRejectOrderId(orderId);
//         setRejectNote("");
//         setShowRejectModal(true);
//     };

//     const openImageModal = (images) => {
//         setPreviewImages(images);
//         setShowImageModal(true);
//     };

//     // --- Helper: Badge ---
//     const getStatusBadge = (status) => {
//         switch (status) {
//             case 'returnRequested': return <span className='px-3 py-1 bg-yellow-100 text-yellow-700 rounded-full text-xs font-bold border border-yellow-200 whitespace-nowrap'>Return Requested</span>;
//             case 'returnAccepted': return <span className='px-3 py-1 bg-green-100 text-green-700 rounded-full text-xs font-bold border border-green-200 whitespace-nowrap'>Accepted</span>;
//             case 'returnRejected': return <span className='px-3 py-1 bg-red-100 text-red-700 rounded-full text-xs font-bold border border-red-200 whitespace-nowrap'>Rejected</span>;
//             case 'returned': return <span className='px-3 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-bold border border-blue-200 whitespace-nowrap'>Returned (Done)</span>;
//             default: return <span className='px-3 py-1 bg-gray-100 text-gray-600 rounded-full text-xs font-bold whitespace-nowrap'>{status}</span>;
//         }
//     };

//     const tabs = [
//         { id: "", label: "All Returns" },
//         { id: "returnRequested", label: "Pending Request" },
//         { id: "returnAccepted", label: "Accepted" },
//         { id: "returnRejected", label: "Rejected" },
//     ];

//     return (
//         <div className="min-h-screen">
//             <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                
//                 {/* Header */}
//                 <div className="flex justify-between items-center mb-6">
//                     <h2 className="text-2xl font-bold text-gray-800">Return Orders</h2>
//                     <button onClick={fetchOrders} className="text-sm text-blue-600 hover:underline">Refresh</button>
//                 </div>

//                 {/* Tabs */}
//                 <div className="flex gap-2 border-b mb-6 overflow-x-auto pb-2">
//                     {tabs.map((tab) => (
//                         <button
//                             key={tab.id}
//                             onClick={() => setSelectedTab(tab.id)}
//                             className={`px-4 py-2 text-sm font-medium rounded-t-lg transition-colors whitespace-nowrap ${
//                                 selectedTab === tab.id ? "bg-blue-50 text-blue-700 border-b-2 border-blue-600" : "text-gray-500 hover:text-gray-700"
//                             }`}
//                         >
//                             {tab.label}
//                         </button>
//                     ))}
//                 </div>

//                 {/* Table */}
//                 <div className="overflow-x-auto">
//                     <table className="w-full text-left border-collapse">
//                         <thead>
//                             <tr className="bg-gray-50 border-b text-gray-500 text-xs uppercase tracking-wider">
//                                 <th className="p-4 font-semibold">Order Info</th>
//                                 <th className="p-4 font-semibold">Customer</th>
//                                 <th className="p-4 font-semibold">Returned Items</th>
//                                 <th className="p-4 font-semibold">Reason & Proof</th>
//                                 <th className="p-4 font-semibold">Status</th>
//                                 <th className="p-4 font-semibold text-right">Actions</th>
//                             </tr>
//                         </thead>
//                         <tbody className="divide-y divide-gray-100 text-sm">
//                             {loading ? (
//                                 <tr><td colSpan="6" className="p-8 text-center text-gray-500 animate-pulse">Loading returns...</td></tr>
//                             ) : orders.length === 0 ? (
//                                 <tr><td colSpan="6" className="p-8 text-center text-gray-500">No return orders found.</td></tr>
//                             ) : (
//                                 orders.map((order) => {
//                                     // Calculate items to display based on returnItems array
//                                     const returnedItemsList = order.items.filter(item => 
//                                         !order.returnItems || order.returnItems.length === 0 || order.returnItems.includes(item._id)
//                                     );
                                    
//                                     // Use original items if filter results in empty (legacy data handling)
//                                     const itemsDisplay = returnedItemsList.length > 0 ? returnedItemsList : order.items;

//                                     return (
//                                         <tr key={order._id} className="hover:bg-gray-50 transition-colors">
//                                             <td className="p-4 align-top">
//                                                 <div className="font-bold text-gray-800 whitespace-nowrap">#{order.razorpayOrderId.slice(6).toUpperCase()}</div>
//                                                 <div className="text-gray-400 text-xs mt-1 whitespace-nowrap">{moment(order.createdAt).format("MMM Do YYYY")}</div>
//                                             </td>
                                            
//                                             <td className="p-4 align-top">
//                                                 <div className="font-medium text-gray-800">{order.customerInfo?.name || order.userId?.name || "Unknown"}</div>
//                                                 <div className="text-gray-500 text-xs mt-0.5">{order.customerInfo?.email || order.userId?.email}</div>
//                                                 <div className="text-gray-500 text-xs">{order.customerInfo?.phone || order.userId?.phone}</div>
//                                             </td>

//                                             {/* --- CHANGED: Using the Sub-Component here --- */}
//                                             <td className="p-4 align-top pr-8">
//                                                 <ReturnItemsList items={itemsDisplay} />
//                                             </td>

//                                             <td className="p-4 align-top min-w-40 max-w-[200px]">
//                                                 <div className="text-gray-800 text-xs font-medium bg-gray-100 p-2 rounded">
//                                                     "{order.returnReason || "No reason provided"}"
//                                                 </div>
                                                
//                                                 {order.returnImages && order.returnImages.length > 0 && (
//                                                     <button 
//                                                         onClick={() => openImageModal(order.returnImages)}
//                                                         className="mt-2 text-[10px] flex items-center gap-1 text-blue-600 hover:text-blue-800 font-medium"
//                                                     >
//                                                         <ImageIcon size={12} /> View Customer Proof ({order.returnImages.length})
//                                                     </button>
//                                                 )}

//                                                 {order.returnRejectedReason && (
//                                                      <div className="mt-2 text-red-500 text-[10px] border-l-2 border-red-300 pl-2">
//                                                         <span className="font-bold">Note:</span> {order.returnRejectedReason}
//                                                      </div>
//                                                 )}
//                                             </td>

//                                             <td className="p-4 align-top">
//                                                 {getStatusBadge(order.status)}
//                                             </td>

//                                             <td className="p-4 align-top text-right">
//                                                 {order.status === "returnRequested" ? (
//                                                     <div className="flex flex-col gap-2 items-end">
//                                                         <button
//                                                             onClick={() => handleAction(order._id, "returnAccepted")}
//                                                             disabled={actionLoading === order._id}
//                                                             className="flex items-center gap-1 px-3 py-1.5 bg-green-600 text-white text-xs font-medium rounded hover:bg-green-700 transition disabled:opacity-50"
//                                                         >
//                                                             {actionLoading === order._id ? "..." : <><CheckCircle size={14}/> Accept</>}
//                                                         </button>
                                                        
//                                                         <button
//                                                             onClick={() => openRejectModal(order._id)}
//                                                             disabled={actionLoading === order._id}
//                                                             className="flex items-center gap-1 px-3 py-1.5 bg-red-100 text-red-600 text-xs font-medium rounded border border-red-200 hover:bg-red-200 transition disabled:opacity-50"
//                                                         >
//                                                             <XCircle size={14}/> Reject
//                                                         </button>
//                                                     </div>
//                                                 ) : (
//                                                     <div className="text-gray-400 text-xs font-medium">Action Taken</div>
//                                                 )}
//                                             </td>
//                                         </tr>
//                                     );
//                                 })
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>

//             {/* --- REJECT MODAL --- */}
//             {showRejectModal && (
//                 <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm">
//                     <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6 m-4 animate-in fade-in zoom-in">
//                         <div className="flex justify-between items-center mb-4">
//                             <h3 className="text-lg font-bold text-gray-800">Reject Request</h3>
//                             <button onClick={() => setShowRejectModal(false)}><X size={20} className="text-gray-500" /></button>
//                         </div>
//                         <p className="text-sm text-gray-500 mb-4">Why are you rejecting this return? (Visible to customer)</p>
//                         <textarea
//                             value={rejectNote}
//                             onChange={(e) => setRejectNote(e.target.value)}
//                             placeholder="Reason for rejection..."
//                             className="w-full p-3 border rounded-lg text-sm outline-none h-24 resize-none mb-4"
//                         ></textarea>
//                         <div className="flex gap-3 justify-end">
//                             <button onClick={() => setShowRejectModal(false)} className="px-4 py-2 text-sm text-gray-600 bg-gray-100 rounded-lg">Cancel</button>
//                             <button 
//                                 onClick={() => handleAction(rejectOrderId, "returnRejected", rejectNote)}
//                                 disabled={!rejectNote.trim() || actionLoading === rejectOrderId}
//                                 className="px-4 py-2 text-sm text-white bg-red-600 rounded-lg hover:bg-red-700 disabled:opacity-50"
//                             >
//                                 Confirm Rejection
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}

//             {/* --- IMAGE PROOF MODAL --- */}
//             {showImageModal && (
//                 <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-80 backdrop-blur-sm p-4">
//                     <div className="bg-white rounded-xl shadow-2xl w-full max-w-3xl max-h-[90vh] flex flex-col">
//                         <div className="p-4 border-b flex justify-between items-center">
//                             <h3 className="font-bold text-gray-800">Customer Proof Images</h3>
//                             <button onClick={() => setShowImageModal(false)} className="p-1 hover:bg-gray-100 rounded-full"><X size={20}/></button>
//                         </div>
//                         <div className="p-6 overflow-y-auto grid grid-cols-2 md:grid-cols-3 gap-4">
//                             {previewImages.map((img, idx) => (
//                                 <div key={idx} className="group relative border rounded-lg overflow-hidden h-48 bg-gray-50">
//                                     <img src={img} alt="Proof" className="w-full h-full object-contain" />
//                                     <a href={img} target="_blank" rel="noreferrer" className="absolute top-2 right-2 p-1.5 bg-white rounded-full shadow opacity-0 group-hover:opacity-100 transition-opacity text-blue-600">
//                                         <ExternalLink size={16} />
//                                     </a>
//                                 </div>
//                             ))}
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </div>
//     );
// };

// export default AllReturnOrders;

import React, { useCallback, useEffect, useState } from 'react';
import api from '../common/apiClient'; 
import SummaryApi from '../common/SummaryApi';
import { toast } from 'react-hot-toast';
import { 
    CheckCircle, 
    XCircle, 
    X, 
    Image as ImageIcon, 
    ExternalLink, 
    ChevronDown, 
    ChevronUp,
    Calendar,
    User,
} from 'lucide-react';
import moment from 'moment';
import Pagination from '../helpers/Pagination';

// --- SUB COMPONENT: Handles the Expand/Collapse logic for items ---
const ReturnItemsList = ({ items }) => {
    const [expanded, setExpanded] = useState(false);

    if (!items || items.length === 0) return null;

    const visibleItems = expanded ? items : [items[0]];
    const remainingCount = items.length - 1;

    return (
        <div className="space-y-3">
            {visibleItems.map((item, idx) => {
                const imgUrl = item.variantId?.images?.[0] || item.productId?.images?.[0] || "";
                
                return (
                    <div key={idx} className="flex gap-3 items-center animate-in fade-in duration-300">
                        {/* Product Image Style from Reference */}
                        <div className="w-10 h-10 bg-gray-50 rounded-lg flex items-center justify-center border border-gray-100 shrink-0 overflow-hidden">
                            <img 
                                src={imgUrl} 
                                alt="" 
                                className="w-full h-full object-cover"
                            />
                        </div>
                        
                        {/* Product Text Style from Reference */}
                        <div className="max-w-[200px]">
                            <div className="text-sm font-bold text-gray-700 truncate" title={item.productId?.productName}>
                                {item.productId?.productName}
                            </div>
                            <div className="text-[10px] text-gray-400 font-bold uppercase flex flex-wrap gap-2">
                                {item.variantId?.colorName && <span>{item.variantId.colorName}</span>}
                                {item.sizeId?.size && <span>Size: {item.sizeId.size}</span>}
                                <span>Qty: {item.quantity}</span>
                            </div>
                        </div>
                    </div>
                );
            })}

            {/* Show More / Show Less Button */}
            {items.length > 1 && (
                <button 
                    onClick={(e) => { e.stopPropagation(); setExpanded(!expanded); }} 
                    className="text-[11px] font-bold text-blue-600 hover:text-blue-800 hover:underline flex items-center gap-1 mt-1 transition-colors ml-12"
                >
                    {expanded ? (
                        <>Show Less <ChevronUp size={12} /></>
                    ) : (
                        <>+{remainingCount} more items <ChevronDown size={12} /></>
                    )}
                </button>
            )}
        </div>
    );
};

// --- MAIN COMPONENT ---
const AllReturnOrders = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedTab, setSelectedTab] = useState("");
    const [actionLoading, setActionLoading] = useState(null);

    // --- Pagination State ---
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); 

    // --- Modal States ---
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectOrderId, setRejectOrderId] = useState(null);
    const [rejectNote, setRejectNote] = useState("");
    const [showImageModal, setShowImageModal] = useState(false);
    const [previewImages, setPreviewImages] = useState([]);

    // --- Fetch Orders ---
    const fetchOrders = useCallback(async () => {
        setLoading(true);
        try {
            let url = SummaryApi.getReturnedOrders.url;
            if (selectedTab) {
                url += `?status=${selectedTab}`;
            }

            const response = await api({
                url: url,
                method: SummaryApi.getReturnedOrders.method,
                withCredentials: true
            });

            const responseData = response.data;

            if (responseData.success) {
                setOrders(responseData.data || []); 
                setCurrentPage(1); // Reset to first page on tab/fetch change
            } else {
                toast.error(responseData.message || "Failed to fetch orders");
            }
        } catch (error) {
            console.error(error);
            const msg = error.response?.data?.message || "Something went wrong";
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    }, [selectedTab]);

    useEffect(() => {
        fetchOrders();
    }, [fetchOrders]);

    // --- Handle Actions ---
    const handleAction = async (orderId, status, note = "") => {
        setActionLoading(orderId);
        try {
            const response = await api({
                url: SummaryApi.adminReturnAction.url(orderId),
                method: SummaryApi.adminReturnAction.method,
                withCredentials: true,
                headers: { "Content-Type": "application/json" },
                data: { status, note }
            });

            if (response.data.success) {
                toast.success(response.data.message);
                fetchOrders();
                setShowRejectModal(false);
                setRejectNote("");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            const msg = error.response?.data?.message || "Error updating status";
            toast.error(msg);
        } finally {
            setActionLoading(null);
        }
    };

    const openRejectModal = (orderId) => {
        setRejectOrderId(orderId);
        setRejectNote("");
        setShowRejectModal(true);
    };

    const openImageModal = (images) => {
        setPreviewImages(images);
        setShowImageModal(true);
    };

    // --- Helper: Badge ---
    const getStatusBadge = (status) => {
        const baseClass = "inline-flex items-center gap-1.5 px-3 py-1 rounded-md text-[10px] font-black uppercase tracking-wider";
        
        switch (status) {
            case 'returnRequested': 
                return <span className={`${baseClass} bg-yellow-100 text-yellow-700`}>Requested</span>;
            case 'returnAccepted': 
                return <span className={`${baseClass} bg-green-100 text-green-700`}>Accepted</span>;
            case 'returnRejected': 
                return <span className={`${baseClass} bg-red-100 text-red-700`}>Rejected</span>;
            case 'returned': 
                return <span className={`${baseClass} bg-blue-100 text-blue-700`}>Returned</span>;
            default: 
                return <span className={`${baseClass} bg-gray-100 text-gray-600`}>{status}</span>;
        }
    };

    const tabs = [
        { id: "", label: "All Returns" },
        { id: "returnRequested", label: "Pending" },
        { id: "returnAccepted", label: "Accepted" },
        { id: "returnRejected", label: "Rejected" },
    ];

    // --- Pagination Calculation ---
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentOrders = orders.slice(indexOfFirstItem, indexOfLastItem);

    return (
        <div className="min-h-screen">
            
            {/* Header Area */}
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h2 className="text-2xl font-bold mb-6 text-gray-800">Return Orders</h2>
                </div>
                <button onClick={fetchOrders} className="text-xs font-bold text-blue-600 hover:text-blue-800">Refresh</button>
            </div>

            {/* Tabs */}
            <div className="flex gap-2 mb-6 border-b border-gray-200">
                {tabs.map((tab) => (
                    <button
                        key={tab.id}
                        onClick={() => setSelectedTab(tab.id)}
                        className={`px-6 py-3 text-[11px] font-bold uppercase tracking-widest transition-all border-b-2 ${
                            selectedTab === tab.id 
                            ? "border-blue-600 text-blue-600 bg-blue-50/50" 
                            : "border-transparent text-gray-400 hover:text-gray-600 hover:bg-gray-50"
                        }`}
                    >
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* --- TABLE CONTAINER --- */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden mb-6 flex flex-col">
                <div className="overflow-x-auto">
                    <table className="w-full border-collapse">
                        {/* Header */}
                        <thead>
                            <tr className="bg-blue-600 text-white text-left text-[11px] uppercase tracking-widest font-bold">
                                <th className="p-4 w-12 text-center">S.No</th>
                                <th className="p-4">Order Details</th>
                                <th className="p-4">Customer</th>
                                <th className="p-4">Returned Products</th>
                                <th className="p-4">Reason & Status</th>
                                <th className="p-4 text-right">Actions</th>
                            </tr>
                        </thead>

                        <tbody className="divide-y divide-gray-100">
                            {loading ? (
                                <tr><td colSpan="6" className="p-10 text-center text-gray-400 font-medium text-xs uppercase tracking-wider">Loading returns...</td></tr>
                            ) : orders.length === 0 ? (
                                <tr><td colSpan="6" className="p-10 text-center text-gray-400 font-medium text-xs uppercase tracking-wider">No return orders found.</td></tr>
                            ) : (
                                currentOrders.map((order, index) => {
                                    const returnedItemsList = order.items.filter(item => 
                                        !order.returnItems || order.returnItems.length === 0 || order.returnItems.includes(item._id)
                                    );
                                    const itemsDisplay = returnedItemsList.length > 0 ? returnedItemsList : order.items;
                                    
                                    // Calculate S.No
                                    const serialNumber = (currentPage - 1) * itemsPerPage + index + 1;

                                    return (
                                        <tr key={order._id} className="hover:bg-blue-50/40 transition-colors group">
                                            
                                            {/* S.No */}
                                            <td className="p-4 align-top text-center text-xs font-bold text-gray-400">
                                                {serialNumber}
                                            </td>

                                            {/* Order Info */}
                                            <td className="p-4 align-top">
                                                <div className="font-mono text-sm font-bold text-gray-700">
                                                    #{order.razorpayOrderId?.slice(6).toUpperCase()}
                                                </div>
                                                <div className="flex items-center gap-2 mt-1 text-[11px] font-bold text-gray-400 uppercase tracking-tight">
                                                    <Calendar size={10} className="text-blue-400"/>
                                                    {moment(order.createdAt).format("MMM Do YYYY")}
                                                </div>
                                            </td>
                                            
                                            {/* Customer Info */}
                                            <td className="p-4 align-top">
                                                <div className="flex items-center gap-2 mb-1">
                                                    <User size={12} className="text-gray-300"/>
                                                    <span className="text-xs font-bold text-gray-700 uppercase tracking-tight">
                                                        {order.customerInfo?.name || order.userId?.name || "Guest"}
                                                    </span>
                                                </div>
                                                <div className="space-y-0.5 ml-5">
                                                    <div className="text-[12px] font-medium text-gray-400 flex items-center gap-1">
                                                        {order.customerInfo?.email || order.userId?.email}
                                                    </div>
                                                    <div className="text-[12px] font-medium text-gray-400 flex items-center gap-1">
                                                        {order.customerInfo?.phone || order.userId?.phone}
                                                    </div>
                                                </div>
                                            </td>

                                            {/* Returned Products */}
                                            <td className="p-4 align-top">
                                                <ReturnItemsList items={itemsDisplay} />
                                            </td>

                                            {/* Reason & Status */}
                                            <td className="p-4 align-top min-w-[200px]">
                                                <div className="mb-3">
                                                    {getStatusBadge(order.status)}
                                                </div>

                                                <div className="p-2 bg-gray-50 rounded border border-gray-100 text-[11px] font-medium text-gray-600 mb-2">
                                                    <span className="font-bold text-gray-400 text-[9px] uppercase block mb-1">Reason:</span>
                                                    "{order.returnReason || "N/A"}"
                                                </div>

                                                {order.returnImages && order.returnImages.length > 0 && (
                                                    <button 
                                                        onClick={() => openImageModal(order.returnImages)}
                                                        className="text-[10px] font-bold text-blue-600 hover:text-blue-800 uppercase tracking-wide flex items-center gap-1"
                                                    >
                                                        <ImageIcon size={12} /> View Proof ({order.returnImages.length})
                                                    </button>
                                                )}

                                                {order.returnRejectedReason && (
                                                     <div className="mt-2 text-red-500 text-[12px] border-l-2 border-red-300 pl-2">
                                                        <span className="font-bold uppercase text-[9px]">Admin Note:</span><br/>
                                                        {order.returnRejectedReason}
                                                     </div>
                                                )}
                                            </td>

                                            {/* Actions */}
                                            <td className="p-4 align-top text-right">
                                                {order.status === "returnRequested" ? (
                                                    <div className="flex flex-col gap-2 items-end">
                                                        <button
                                                            onClick={() => handleAction(order._id, "returnAccepted")}
                                                            disabled={actionLoading === order._id}
                                                            className="flex items-center justify-center gap-1.5 w-24 py-1.5 bg-green-600 text-white text-[10px] font-bold uppercase tracking-wider rounded-md hover:bg-green-700 transition disabled:opacity-50 shadow-sm"
                                                        >
                                                            {actionLoading === order._id ? "..." : <><CheckCircle size={12}/> Accept</>}
                                                        </button>
                                                        
                                                        <button
                                                            onClick={() => openRejectModal(order._id)}
                                                            disabled={actionLoading === order._id}
                                                            className="flex items-center justify-center gap-1.5 w-24 py-1.5 bg-white border border-red-200 text-red-600 text-[10px] font-bold uppercase tracking-wider rounded-md hover:bg-red-50 transition disabled:opacity-50"
                                                        >
                                                            <XCircle size={12}/> Reject
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <span className="text-[10px] font-bold text-gray-300 uppercase tracking-widest">
                                                        Completed
                                                    </span>
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </table>
                </div>

                {/* --- PAGINATION COMPONENT --- */}
                {!loading && orders.length > 0 && (
                    <div className="p-4 border-t border-gray-100 bg-gray-50">
                        <Pagination 
                            totalItems={orders.length}
                            itemsPerPage={itemsPerPage}
                            currentPage={currentPage}
                            onPageChange={setCurrentPage}
                        />
                    </div>
                )}
            </div>

            {/* --- REJECT MODAL --- */}
            {showRejectModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
                    <div className="bg-white rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in duration-200">
                        <div className="bg-gray-50 px-6 py-4 border-b border-gray-100 flex justify-between items-center">
                            <h3 className="text-sm font-black text-gray-800 uppercase tracking-widest">Reject Return</h3>
                            <button onClick={() => setShowRejectModal(false)} className="text-gray-400 hover:text-red-500 transition-colors"><X size={18} /></button>
                        </div>
                        
                        <div className="p-6">
                            <p className="text-xs font-bold text-gray-500 uppercase tracking-wide mb-3">Reason for rejection (Visible to customer)</p>
                            <textarea
                                value={rejectNote}
                                onChange={(e) => setRejectNote(e.target.value)}
                                placeholder="E.g. Product tags are missing..."
                                className="w-full p-4 border border-gray-200 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none h-32 resize-none mb-6 bg-gray-50"
                            ></textarea>

                            <div className="flex gap-3">
                                <button 
                                    onClick={() => setShowRejectModal(false)} 
                                    className="flex-1 py-3 text-xs font-bold text-gray-500 uppercase tracking-wider bg-gray-100 rounded-xl hover:bg-gray-200 transition-colors"
                                >
                                    Cancel
                                </button>
                                <button 
                                    onClick={() => handleAction(rejectOrderId, "returnRejected", rejectNote)}
                                    disabled={!rejectNote.trim() || actionLoading === rejectOrderId}
                                    className="flex-1 py-3 text-xs font-bold text-white uppercase tracking-wider bg-red-600 rounded-xl hover:bg-red-700 transition-colors disabled:opacity-50 shadow-lg shadow-red-200"
                                >
                                    Confirm Rejection
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* --- IMAGE PROOF MODAL --- */}
            {showImageModal && (
                <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] flex flex-col overflow-hidden">
                        <div className="bg-white px-6 py-4 border-b border-gray-100 flex justify-between items-center shrink-0">
                            <h3 className="text-sm font-black text-gray-800 uppercase tracking-widest">Customer Proof</h3>
                            <button onClick={() => setShowImageModal(false)} className="bg-gray-100 p-2 rounded-full hover:bg-gray-200 transition"><X size={18}/></button>
                        </div>
                        <div className="p-8 overflow-y-auto grid grid-cols-2 md:grid-cols-3 gap-6 bg-gray-50 h-full">
                            {previewImages.map((img, idx) => (
                                <div key={idx} className="group relative bg-white border border-gray-200 rounded-xl overflow-hidden aspect-square shadow-sm hover:shadow-md transition-all">
                                    <img src={img} alt="Proof" className="w-full h-full object-contain p-2" />
                                    <a href={img} target="_blank" rel="noreferrer" className="absolute top-3 right-3 p-2 bg-white rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-all text-blue-600 hover:text-blue-700">
                                        <ExternalLink size={16} />
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AllReturnOrders;